import { useEffect, useState } from 'react';
import type { Editor, EditorEvents } from '@tiptap/react';

type AIStorage = {
  ai?: {
    state?: 'idle' | 'loading' | 'streaming' | 'error';
  };
};

export const useIsAIGenerating = (editor: Editor | null): boolean => {
  const [isGenerating, setIsGenerating] = useState(false);

  useEffect(() => {
    if (!editor) {
      setIsGenerating(false);
      return;
    }

    const checkAIGenerationState = (currentEditor: Editor) => {
      const aiStorage = (currentEditor.storage as AIStorage)?.ai;
      const isGeneratingState = aiStorage?.state === 'loading' || aiStorage?.state === 'streaming';

      setIsGenerating(isGeneratingState);
    };

    const handleTransaction = ({ editor: currentEditor }: EditorEvents['transaction']) => {
      checkAIGenerationState(currentEditor);
    };

    editor.on('transaction', handleTransaction);

    return () => {
      editor.off('transaction', handleTransaction);
    };
  }, [editor]);

  return isGenerating;
};
